import { Country, LookUpType, Parish } from '~/types'
import { LocalStorageKey } from './literals'
import { useEffect } from 'react'
import { atom, useAtom } from 'jotai'

export interface StaticLookup {
    jmIdTypes: LookUpType[]
    countries: Country[]
    jmParishes: Parish[]
    bbParishes: Parish[]
    bbIdTypes: LookUpType[]
    addressTypes: LookUpType[]
    emailTypes: LookUpType[]
    phoneTypes: LookUpType[]
    relationships: LookUpType[]
    accountTypes: LookUpType[]
    jmBankNames: LookUpType[]
    bbBankNames: LookUpType[]
    bankBranches: LookUpType[]
}

export const emptyStaticLookup: StaticLookup = {
    countries: [],
    jmParishes: [],
    bbParishes: [],
    addressTypes: [],
    emailTypes: [],
    phoneTypes: [],
    relationships: [],
    jmIdTypes: [],
    bbIdTypes: [],
    accountTypes: [],
    jmBankNames: [],
    bbBankNames: [],
    bankBranches: [],
}

export function GetStaticLookup(): StaticLookup {
    const [lookup, setStaticLookup] = useAtom(staticLookupAtom)

    useEffect(() => {
        const val = localStorage.getItem(LocalStorageKey.StaticLookup)
        const lookup = val ? JSON.parse(val) : emptyStaticLookup
        setStaticLookup(lookup)
    }, [])

    return lookup
}

export const staticLookupAtom = atom<StaticLookup>(emptyStaticLookup)
